import { render, staticRenderFns } from "./QueryPlayground.vue?vue&type=template&id=0cba4a09&"
import script from "./QueryPlayground.vue?vue&type=script&lang=js&"
export * from "./QueryPlayground.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports